import { render } from "./ActionKey.vue?vue&type=template&id=72c2e6b8"
import script from "./ActionKey.vue?vue&type=script&lang=js"
export * from "./ActionKey.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__